// extracted by mini-css-extract-plugin
export default {"pointsBox":"CollectionPoint_pointsBox__nZauK","title":"CollectionPoint_title__tUs2P","divide":"CollectionPoint_divide__rSM8y"};